import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tutorials from './pages/Tutorials';
import Downloads from './pages/Downloads';
import AiLauncher from './pages/AiLauncher';
import Community from './pages/Community';
import Admin from './pages/Admin';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ai-launcher" element={<AiLauncher />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/community" element={<Community />} />
              <Route path="/tutorials" element={<Tutorials />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;

